import { useEffect, useState } from "react";

// Reading-progress bar shared by the essay and travel article pages
const ReadProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const doc = document.documentElement;
        const max = (doc.scrollHeight - doc.clientHeight) || 1;
        setPct(Math.min(1, Math.max(0, window.scrollY / max)));
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="read-progress" aria-hidden="true">
      <div className="read-progress-fill" style={{ transform: `scaleX(${pct})` }} />
    </div>
  );
};

export default ReadProgress;
